import { render, staticRenderFns } from "./BrandProviderItem.vue?vue&type=template&id=43c29578&scoped=true"
import script from "./BrandProviderItem.vue?vue&type=script&lang=js"
export * from "./BrandProviderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c29578",
  null
  
)

export default component.exports